import { ParamIds, Places } from 'src/Constants'
import GrupoKeys from '../grupo.keys'

export class GrupoFormKeys extends GrupoKeys {
    get place() {
        return Places.mcGrupoForm
    }

    get grupoId() {
        return this._intent.getParameterAsNumber(ParamIds.mcGrupoFormId)
    }

    set grupoId(value: number | undefined) {
        this._intent.setParameter(ParamIds.mcGrupoFormId, value)
    }

    get addAnaliseId() {
        return this._intent.getParameterAsNumber(ParamIds.mcAnaliseSelectId)
    }

    set addAnaliseId(value: number | undefined) {
        this._intent.setParameter(ParamIds.mcAnaliseSelectId, value)
    }
}
